<template>
  <TheFooter>
    <div>
      <!--footer-->
      <a href="https://admin.lacoreconnect.com">v{{ getVersion }}</a>
      <span class="ml-1"
        >Lacore Connect</span
      >
    </div>
    <div class="ml-auto">
      <button
        class="btn btn-sm btn-outline-danger mr-2"
        @click="openDocs"
      >
        <i class="fa fa-info mr-2" />
        <span>Knowledge Base</span>
      </button>
      <router-link
        class="btn btn-sm btn-outline-info mr-2"
        :to="{name: 'ChangelogPublic'}"
      >
        <i class="fa fa-info mr-2" />
        <span>Changelog</span>
      </router-link>
      <a
        class="btn btn-sm btn-outline-warning mr-2"
        href="http://status.lacoreconnect.com/"
        target="_blank"
      >
        <i class="fa fa-info mr-2" />
        <span>Status</span>
      </a>
      <!-- <a
        class="btn btn-sm btn-outline-info mr-2"
        href="/help/index.html"
        target="_blank"
      >
        <i class="fa fa-life-ring mr-2" />
        <span>Documentation</span>
      </a> -->

      <!-- <span class="mr-1">Powered by</span>
      <a href="https://commissions.io">commissions.io</a> -->
    </div>
  </TheFooter>
</template>
<script>
import { Footer as TheFooter } from '@coreui/vue';
import { mapGetters } from 'vuex';
export default {
  name: 'DefaultFooter',
  computed: {
    ...mapGetters(['getVersion','getAppEnv'])
  },
  components: {
    TheFooter
  },
  mounted() {
    this.subscribeForPushNotifications();
  },
  methods: {
    openDocs() {
      var form = document.createElement('form');
      form.method = 'POST';
      let docsSubDomain = 'docs';
      form.action = 'https://'+docsSubDomain+'.lacoreconnect.com/s/management';
      form.target = '_blank';
      form.style.display = 'none';
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'auth_token';
      input.value = this.$store.getters['account/getToken']
      form.appendChild(input);
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    },
    urlB64ToUint8Array(base64String) {
      let padding = '='.repeat((4 - base64String.length % 4) % 4);
      let base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

        let rawData = window.atob(base64);
        let outputArray = new Uint8Array(rawData.length);

      for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
      }
      return outputArray;
    },
    subscribeForPushNotifications() {
      if(window.uxAppServiceWorkerRegistration) {
        let applicationServerPublicKey = this.urlB64ToUint8Array('BOKZeo5BJ7mg9JeYg-soYUbDUR5bnPmMI6gCRefXGTth1XPVYz6d1jf0-bpa7VK7dPp9hBGMB3rtzCwHSQz_HsI');

          window.uxAppServiceWorkerRegistration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: applicationServerPublicKey
        }).then((pushSubscription) => {
          let userSub = pushSubscription.toJSON();
          let userSubInfoToSave = {
            endpoint: userSub.endpoint,
            p256dh: userSub.keys.p256dh,
            auth: userSub.keys.auth
          }
          this.$http.post('/api/common/save-push-subscription', userSubInfoToSave)
          .then((resp) => {

          }).catch((err) => {
            console.error('Could not save web push sub entity!', err);
          })
            /*fetch('push-notifications-api/subscriptions', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(pushSubscription)
            }).then(function (response) {
                if (response.ok) {
                    console.log('Successfully subscribed for Push Notifications');
                } else {
                    console.log('Failed to store the Push Notifications subscription on server');
                }
            }).catch(function (error) {
                console.log('Failed to store the Push Notifications subscription on server: ' + error);
            });*/

        }).catch(function (error) {
            if (Notification.permission === 'denied') {
                //...
                console.log('Push Notifications Were Denied!');
            } else {
                console.log('Failed to subscribe for Push Notifications: ' + error);
            }
        });
      }
  }
  }
};
</script>
